// import React, { Fragment } from "react";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "react-datepicker/dist/react-datepicker.css";
// import { MuiPickersUtilsProvider } from "@material-ui/pickers";
// import MomentUtils from "@date-io/moment";
// // import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
// import { ThemeProvider } from "@material-ui/core/styles";
// import createTheme from "@material-ui/core/styles/createTheme";

// import { Provider } from "react-redux";
// import reducersStore from "./src/reducers/store";
// import { getUserSession, getLocalStorage } from "./src/utils/localStorage";
// import { getThemeConfigs } from "./src/theme";
// import SnackbarLayout from "./src/utils/helper/Snakbar";
// import WindowLayout from "./src/app/main/helperComponents/UseWindowSize";

// // if (getUserSession()) reducersStore.dispatch(fetchUserProfile());

// const theme = getLocalStorage("app_theme");

// const themeStore = createTheme({
//   ...getThemeConfigs(theme ? theme : "light"),
// });

// // eslint-disable-next-line react/display-name,react/prop-types
// export default ({ element }) => {
//   // Instantiating store in `wrapRootElement` handler ensures:
//   //  - there is fresh store for each SSR page
//   //  - it will be called only once in browser, when React mounts

//   return (
//     <Fragment>
//       <Provider store={reducersStore}>
//         <ThemeProvider theme={themeStore}>
//           <MuiPickersUtilsProvider utils={MomentUtils}>
//             <SnackbarLayout>{element}</SnackbarLayout>
//             <WindowLayout />
//           </MuiPickersUtilsProvider>
//         </ThemeProvider>
//       </Provider>
//     </Fragment>
//   );
// };

import React, { Fragment } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { Provider } from "react-redux";
import reducersStore from "./src/reducers/store";
import { getUserSession, getLocalStorage } from "./src/utils/localStorage";
import { getThemeConfigs } from "./src/theme";
import SnackbarLayout from "./src/utils/helper/Snakbar";
import WindowLayout from "./src/app/main/helperComponents/UseWindowSize";
import AuthGateProvider from "./src/utils/AuthGateProvider";
import SubscriptionGateProvider from "./src/utils/SubscriptionGateProvider";

// if (getUserSession()) reducersStore.dispatch(fetchUserProfile());

const theme = getLocalStorage("app_theme");

const themeStore = createTheme({
  ...getThemeConfigs(theme ? theme : "light"),
});

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => {
  return (
    <Fragment>
      <Provider store={reducersStore}>
        <ThemeProvider theme={themeStore}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <AuthGateProvider>
              <SubscriptionGateProvider>
                <SnackbarLayout>{element}</SnackbarLayout>
                <WindowLayout />
              </SubscriptionGateProvider>
            </AuthGateProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </Provider>
    </Fragment>
  );
};
